var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9043 14.5529L15.9043 17.0285C15.9043 17.5703 15.7976 18.1069 15.5902 18.6075C15.3829 19.1081 15.0789 19.5629 14.6958 19.9461C14.3127 20.3292 13.8578 20.6331 13.3572 20.8405C12.8566 21.0478 12.3201 21.1545 11.7783 21.1545C11.2364 21.1545 10.6999 21.0478 10.1993 20.8405C9.69871 20.6331 9.24386 20.3292 8.86072 19.9461C8.47758 19.5629 8.17366 19.1081 7.96631 18.6075C7.75895 18.1069 7.65223 17.5703 7.65223 17.0285L7.65223 14.5529M7.65223 9.60165L7.65223 7.12603C7.65223 6.58419 7.75896 6.04766 7.96631 5.54707C8.17366 5.04647 8.47758 4.59162 8.86072 4.20849C9.6345 3.43471 10.684 3 11.7783 3C12.8726 3 13.922 3.43471 14.6958 4.20849C15.4696 4.98227 15.9043 6.03174 15.9043 7.12603L15.9043 9.60165",
    stroke: "#16192C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7773 8.77637L11.7773 15.378",
    stroke: "#16192C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.5f89ee1cd69c4026ed69e386f8f51b50.svg";
export { ForwardRef as ReactComponent };